<div class="sidebar flex-shrink-0 d-flex flex-column" [class.sidebar-collapsed]="!expanded">
  <header class="d-flex pt-4 gap-2 align-items-center">
    <img src="./built-in-ai-playground-logo.svg" alt="Built-In AI Playground Logo" class="d-block"/>
    <h1 class="title h6 flex-grow-1">Built-In AI Playground</h1>
  </header>

  <nav class="mt-5 ms-2 me-2 flex-grow-1">
    <ul class="list-unstyled">
      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">
        <a class="btn" routerLink="/">
          <i class="bi bi-house"></i>
          <span>Home</span>
        </a>
      </li>

      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.WebAiStudio">
        <a class="btn" [routerLink]="RouteEnum.WebAiStudio">
          <i class="bi bi-app-indicator"></i>
          <span>WebAI Studio</span>
        </a>
      </li>
<!--      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">-->
<!--        <a class="btn" routerLink="/">-->
<!--          <i class="bi bi-translate"></i>-->
<!--          <span>Translation</span>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">-->
<!--        <a class="btn" routerLink="/">-->
<!--          <i class="bi bi-pencil-square"></i>-->
<!--          <span>Writing Assistance</span>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">-->
<!--        <a class="btn" routerLink="/">-->
<!--          <i class="bi bi-collection-play-fill"></i>-->
<!--          <span>Image Interpretation</span>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">-->
<!--        <a class="btn" routerLink="/">-->
<!--          <i class="bi bi-volume-up"></i>-->
<!--          <span>Audio Interpretation</span>-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Home">-->
<!--        <a class="btn" routerLink="/">-->
<!--          <i class="bi bi-input-cursor"></i>-->
<!--          <span>Auto Completion</span>-->
<!--        </a>-->
<!--      </li>-->

      <li class="navigation-category">
        <i class="bi bi-arrow-left-right"></i> <span>Built-In AI APIs</span>

        <ul class="list-unstyled">
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.TranslatorApi">
            <a class="btn" routerLink="/translator-api">
              <i class="bi bi-translate"></i>
              <span>Translator API</span>
            </a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.LanguageDetectorApi">
            <a class="btn" routerLink="/language-detector-api">
               <i class="bi bi-globe"></i>
             <span>Language Detector API</span>
            </a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.SummarizerApi">
            <a class="btn" routerLink="/summarizer-api">
              <i class="bi bi-text-paragraph"></i>
              <span>Summarizer API</span></a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.WriterApi">
            <a class="btn" routerLink="/writer-api">
              <i class="bi bi-pencil-square"></i>
              <span>Writer API</span></a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.RewriterApi">
            <a class="btn" routerLink="/rewriter-api">
              <i class="bi bi-arrow-clockwise"></i>
              <span>Rewriter API</span></a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.PromptApi">
            <a class="btn" routerLink="/prompt-api">
              <i class="bi bi-input-cursor-text"></i>
              <span>Prompt API</span></a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.ProofreaderApi">
            <a class="btn" routerLink="/proofreader-api">
              <i class="bi bi-spellcheck"></i>
              <span>Proofreader API</span>
              <span class="badge text-bg-warning">Experimental</span>
            </a>

          </li>

          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.SemanticEmbedderApi">
            <a class="btn" routerLink="/semantic-embedder-api">
              <i class="bi bi-diagram-3"></i>
              <span>Semantic Embedder API</span>
              <span class="badge text-bg-warning">Experimental</span>
            </a>
          </li>

          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.MultimodalPromptApi">
            <a class="btn" routerLink="/multimodal-prompt-api">
              <i class="bi bi-collection-play-fill"></i>
              <span>Multimodal Prompt API</span>
            </a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.ImageMultimodalPromptApi">
            <a class="btn" routerLink="/image-multimodal-prompt-api">
              <i class="bi bi-images"></i>
              <span>Image Prompt</span>
            </a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.AudioMultimodalPromptApi">
            <a class="btn" routerLink="/audio-multimodal-prompt-api">
              <i class="bi bi-volume-up"></i>
              <span>Audio Prompt</span>
            </a>
          </li>

        </ul>
      </li>

      <li class="navigation-category">
        <i class="bi bi-tools"></i> <span>Batch Executions</span>
        <ul class="list-unstyled">
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.SummarizerBatchPage">
            <a class="btn" routerLink="/summarizer-batch-page">
              <i class="bi bi-journals"></i>
              <span>Summarizer Batch Page</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="navigation-category">
        <i class="bi bi-window-desktop"></i> <span>Use Cases</span>

        <ul class="list-unstyled">
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.Autocomplete">
            <a class="btn" routerLink="/autocomplete">
              <i class="bi bi-input-cursor"></i>
              <span>Autocomplete</span>
              <span class="badge text-bg-warning">Experimental</span>
            </a>

          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.TranscriptionAudioMultimodalPromptApi">
            <a class="btn" routerLink="/transcription-audio-multimodal-prompt-api">
              <i class="bi bi-voicemail"></i>
              <span>Transcription <small>(using Audio Prompt)</small></span>
              <span class="badge text-bg-warning">Experimental</span>
            </a>
          </li>
        </ul>
      </li>

      <li class="navigation-category">
        <i class="bi bi-speedometer"></i> <span>Performance/Debug</span>
        <ul class="list-unstyled">
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.PerformanceHistory">
            <a class="btn" routerLink="/performance/history">
              <i class="bi bi-clock-history"></i>
              <span>Performance History</span>
            </a>
          </li>
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.PerformanceTestRunner">
            <a class="btn" routerLink="/performance/perf-test-runner">
              <i class="bi bi-speedometer2"></i>
              <span>Performance Test Runner</span>
            </a>
          </li>

        @if(Environment.name !== EnvironmentNameEnum.ChromeDev) {
          <li class="navigation-item" [class.active]="this.currentRoute === RouteEnum.DownloadTester">
            <a class="btn" routerLink="/download-tester">
              <i class="bi bi-percent"></i>
              <span>Download Tester</span>
            </a>
          </li>
        }
        </ul>
      </li>


    </ul>
  </nav>

  <button class="btn btn-sidebar p-3" (click)="toggleSidebar()"><i class="bi bi-layout-sidebar"></i></button>
</div>
